import React, { useCallback, useContext, useMemo, useState } from "react";
import { decryptData, encryptData } from "../utility/encryptionUtility";

const initialState = {
  group: [],
  isNewUser: false,
  userInfo: {
    user_email: "",
    first_name: "",
    last_name: "",
    phone_office: "",
    phone_mobile: "",
    organization: "",
    position: "",
    language: "",
  },
  updateUserData: ({ userInfo, group = [], isNewUser }) => {},
  updateUserNewStatus: (isNewUser) => {},
};

const UserContext = React.createContext(initialState);

const UserContextProvider = ({ children }) => {
  const userInfoObj =
    sessionStorage.getItem("userInfo") == null
      ? initialState
      : JSON.parse(decryptData(sessionStorage.getItem("userInfo")));

  const [userData, setUserData] = useState(userInfoObj);

  // update user Info only
  const updateUserData = useCallback(
    ({ userInfo = {}, group = null, isNewUser = null }) => {
      setUserData((prevState) => {
        const updatedData = {
          ...prevState,
          userInfo: {
            ...prevState.userInfo,
            ...userInfo,
          },
          group: group ?? prevState?.group,
          isNewUser: isNewUser ?? prevState.isNewUser,
        };
        sessionStorage.setItem(
          "userInfo",
          encryptData(JSON.stringify(updatedData))
        );
        return updatedData;
      });
    },
    []
  );

  // once the user creates his acccount, he can use this func to update the context
  const updateUserNewStatus = useCallback((isNewUser) => {
    setUserData((prevState) => ({
      ...prevState,
      isNewUser,
    }));

    sessionStorage.setItem(
      "userInfo",
      encryptData(JSON.stringify({ ...userData, isNewUser }))
    );
  }, []);

  const contextValue = useMemo(
    () => ({
      group: userData.group,
      isNewUser: userData.isNewUser,
      userInfo: userData.userInfo,
      updateUserData,
      updateUserNewStatus,
    }),
    [userData, updateUserData, updateUserNewStatus]
  );

  return (
    <UserContext.Provider value={contextValue}>{children}</UserContext.Provider>
  );
};

const useUserInfo = () => useContext(UserContext);

export { UserContextProvider, useUserInfo as useUser };
